// 审批（销售合同下的业务单据页面配置）
import {
  getContractApprovalListData,
  saveContractApprovalData,
  saveContractApprovalEditData,
  saveContractApprovalDeleteData
} from "../../api/api.js";

export default {
  key: "approval",
  title: "审批",
  short: "审批",
  icon: "completed",
  listFn: getContractApprovalListData,
  saveFn: saveContractApprovalData,
  editFn: saveContractApprovalEditData,
  deleteFn: saveContractApprovalDeleteData,
  // 只读单据：由业务流转自动生成，不允许手工新增 / 编辑 / 删除（列表只保留「点卡片看详情」）
  readonly: true,
  // 卡片标题：审批内容（含门店/日期/事由，可区分）+ 类型 + 提交时间
  titleFields: ["task_descript", "approval_type", "create_time"],
  fields: [
    {
      prop: "approval_type", label: "审批类型", type: "select", required: true, group: "审批信息",
      options: [
        { label: "请假", value: "请假" },
        { label: "报销", value: "报销" },
        { label: "合同审批", value: "合同审批" },
        { label: "其他", value: "其他" }
      ]
    },
    {
      prop: "approval_status", label: "审批状态", type: "select", group: "审批信息",
      options: [
        { label: "待审批", value: "待审批" },
        { label: "通过", value: "通过" },
        { label: "驳回", value: "驳回" }
      ]
    },
    { prop: "remark", label: "备注", type: "textarea", group: "审批信息" }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/contract/Approvals.js